import { render, staticRenderFns } from "./report-zhengxing.vue?vue&type=template&id=5c9fc5fa&scoped=true&"
import script from "./report-zhengxing.vue?vue&type=script&lang=ts&"
export * from "./report-zhengxing.vue?vue&type=script&lang=ts&"
import style0 from "./report-zhengxing.vue?vue&type=style&index=0&id=5c9fc5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9fc5fa",
  null
  
)

export default component.exports